import React from 'react';
import { FiHome, FiUser, FiBriefcase, FiFileText, FiX } from 'react-icons/fi';
import { useSession } from '../../contexts/SessionContext';

const ICONOS = {
  cliente: FiUser,
  proyecto: FiBriefcase,
  factura: FiFileText,
  presupuesto: FiFileText,
};

export default function SessionBar() {
  const { sesiones, sesionActiva, activarSesion, cerrarSesion, irInicio } = useSession();

  if (sesiones.length === 0) return null;

  return (
    <div className="session-bar">
      <button
        className={`session-tab ${sesionActiva === null ? 'session-tab--active' : ''}`}
        onClick={irInicio}
      >
        <FiHome size={14} />
        <span className="session-tab-title">Inicio</span>
      </button>

      {sesiones.map(s => {
        const Icono = ICONOS[s.tipo] || FiFileText;
        const activa = sesionActiva === s.id;
        return (
          <button
            key={s.id}
            className={`session-tab ${activa ? 'session-tab--active' : ''}`}
            onClick={() => activarSesion(s.id)}
          >
            <Icono size={14} />
            <span className="session-tab-title">{s.titulo}</span>
            <button
              type="button"
              className="session-tab-close"
              onClick={e => { e.stopPropagation(); cerrarSesion(s.id); }}
              aria-label="Cerrar sesión"
            >
              <FiX size={12} />
            </button>
          </button>
        );
      })}
    </div>
  );
}
